import { render, staticRenderFns } from "./DepositOverview.vue?vue&type=template&id=6b5ed654"
import script from "./DepositOverview.vue?vue&type=script&lang=js"
export * from "./DepositOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports